module.exports = __webpack_public_path__ + "static/img/prize.f023407.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/public/images/prize.jpg
// module id = KPnf
// module chunks = 1